export type Props = {
  id?: string;
};

const BreadcrumbOutlet = ({ id = 'default-breadcrumb' }: Props) => {
  return <div aria-label="breadcrumb" id={id} />;
};

export default BreadcrumbOutlet;
